<template>
  <div class="tw-max-h-[30px]">
    <SfMultiselect
      v-model="value"
      :append-to-body="true"
      :close-on-select="true"
      mode="single"
      :options="effectiveOptions"
      variant="sf-input"
    >
      <template #option="{ option }">
        <Option>
          {{ option.label }}
        </Option>
      </template>
    </SfMultiselect>
  </div>
</template>

<script setup lang="ts" generic="MV">
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'

import Option from './adjustments-modal-row-cell-select-option.vue'
import SfMultiselect from '@app/shared/vue/components/sf-multiselect.vue'

interface Props {
  options: [string, number][]
  modelValue?: MV
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    'update:modelValue': [value: MV]
  }>()

const value = useVModel(props, 'modelValue', emit)

const effectiveOptions = computed(() => {
  return props.options.map(([label, value]) => {
    return {
      label,
      value,
    }
  })
})
</script>
